"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddBrandMerchantBodyToJSON = exports.AddBrandMerchantBodyFromJSONTyped = exports.AddBrandMerchantBodyFromJSON = void 0;
function AddBrandMerchantBodyFromJSON(json) {
    return AddBrandMerchantBodyFromJSONTyped(json, false);
}
exports.AddBrandMerchantBodyFromJSON = AddBrandMerchantBodyFromJSON;
function AddBrandMerchantBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'brand': json['brand'],
        'merchant': json['merchant'],
        'createMaps': json['createMaps'],
    };
}
exports.AddBrandMerchantBodyFromJSONTyped = AddBrandMerchantBodyFromJSONTyped;
function AddBrandMerchantBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'brand': value.brand,
        'merchant': value.merchant,
        'createMaps': value.createMaps,
    };
}
exports.AddBrandMerchantBodyToJSON = AddBrandMerchantBodyToJSON;
